<div class="d-flex flex-column">
  <div class="d-flex align-items-center v2-mb-1">
    <div class="col-3">
      <typography-v2 look="caption-bold">Cost Type</typography-v2>
    </div>

    <div class="d-flex col-3">
      <typography-v2 look="caption-bold">Per</typography-v2>
    </div>

    <div [ngClass]="props.isDirectPaymentsSupported ? 'col-3' : 'col-6'">
      <typography-v2 look="caption-bold">Amount</typography-v2>
    </div>

    <div *ngIf="props.isDirectPaymentsSupported" class="col-3">
      <typography-v2 look="caption-bold">Pay with Client CC</typography-v2>
    </div>
  </div>

  <div class="d-flex">
    <div class="col-3">
      <dropdown-v2
        (itemSelect)="selectCostCharge($event)"
        [items]="(costCharges$ | async) || []"
        [selectedItem]="selectedCostCharge"
        [disabledDropdown]="form.disabled || !!props.disabled || !!props.readonly"
        placeholder="Type of Cost/Commission"
        data-id="type-of-cost"
      ></dropdown-v2>
    </div>

    <div class="d-flex align-items-center col-3">
      <dropdown-v2
        (itemSelect)="selectPerType($event)"
        [items]="perTypes"
        [selectedItem]="selectedPerType"
        [disabledDropdown]="form.disabled || !!props.disabled || !!props.readonly"
        placeholder="Per"
        data-id="per-type"
      ></dropdown-v2>
    </div>

    <div [ngClass]="props.isDirectPaymentsSupported ? 'col-3' : 'col-6'">
      <div class="currency-input-container align-items-center">
        <input
          (accept)="onAccept()"
          [formControl]="rateControl"
          [imask]="imask"
          [unmask]="true"
          placeholder="Amount"
          class="currency-input"
          data-id="amount"
        />
      </div>
    </div>

    <div *ngIf="props.isDirectPaymentsSupported" class="col-3">
      <dropdown-v2
        (itemSelect)="selectIsDirect($event)"
        [items]="isDirectTypes"
        [selectedItem]="selectedIsDirect"
        [disabledDropdown]="
          form.disabled || !!props.disabled || !!props.readonly || isDirectControl.disabled
        "
        placeholder="Pay with Client CC"
        data-id="is-direct"
      ></dropdown-v2>
    </div>
  </div>
</div>
